import React, { FunctionComponent } from 'react';
import { Text, TextPreset, ShadeColor } from '@pegasus/ui-components/components/text';
import Translate from '@client/components/shared/translation/Translate';


interface Props {
    categorySubline: string[];
};

export const CategorySubline: FunctionComponent<Props> = ({ categorySubline }: Props) => {
    if (!categorySubline || categorySubline.length === 0) {
        return null;
    }

    return (
        <>
            {categorySubline.map((category, index) => (
                <Text preset={TextPreset.XS} color={ShadeColor.dark60} key={index}>
                    {index === 0 ? null : ', '}
                    <Translate message={`categorySubline.${category}`} raw />
                </Text>
            ))}
        </>
    );
}

export default CategorySubline;
